const USER_TYPE = {
  ADMINISTRATOR: '1',
  SUPERUSER: '2',
  USER: '3',
  ASSISTANT: '4',
  USER_SELLER: '20',
  SELLER: '40',
  MAIL_RECEIVER: '70',
  SEEKER_LEAD_GENERATOR: '100',
  SEEKER_FULL_USER: '101',
  ANONYMOUS: '102',
  PENDING: '1000'
};

const PUBLISHER_TYPE = {
  PARTICULAR: '1',
  INMOBILIARIA: '2',
  CONSTRUCTORA: '3',
  CORREDOR: '4',
  AGENCIA: '5',
  INCORPORADORA: '6'
};

export { USER_TYPE, PUBLISHER_TYPE };
